import { useTranslation } from "react-i18next";

import { InformationCarousel } from "@aviary/components/InformationCarousel";
import { NewCarousel } from "@aviary/components/NewCarousel";
import { useFlippers } from "@shared/context/FlippersContext";
import { l } from "@unauthenticated/signupSignin/locales/i18n";

import * as styles from "./StoreSignupInCarousel.styles";

interface Props {
  storeName: string;
}

const StoreSignupInCarousel = ({ storeName }: Props) => {
  const [isVanguardUhCustomExperienceEnabled, isVanguardAscensionCustomExperienceEnabled] =
    useFlippers("vanguard_uh_custom_experience", "vanguard_ascension_custom_experience");
  const { t } = useTranslation();

  let customSlide4Copy;
  if (isVanguardUhCustomExperienceEnabled) {
    customSlide4Copy = l.UH.storeLandingPages.leftColumn.carousel;
  }
  if (isVanguardAscensionCustomExperienceEnabled) {
    customSlide4Copy = l.ascension.storeLandingPages.leftColumn.carousel;
  }

  return (
    <div css={styles.carouselContainer}>
      <InformationCarousel>
        <NewCarousel.Item>
          {t(l.patientRxAuth.storeLandingPages.leftColumn.carousel.slide1)}
        </NewCarousel.Item>
        <NewCarousel.Item>
          {t(l.patientRxAuth.storeLandingPages.leftColumn.carousel.slide2)}
        </NewCarousel.Item>
        <NewCarousel.Item>
          {t(l.patientRxAuth.storeLandingPages.leftColumn.carousel.slide3)}
        </NewCarousel.Item>
        {!!customSlide4Copy && (
          <NewCarousel.Item>
            {t(customSlide4Copy.slide4, {
              storeName,
              interpolation: { escapeValue: false },
            })}
          </NewCarousel.Item>
        )}
      </InformationCarousel>
    </div>
  );
};

export { StoreSignupInCarousel };
